import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebaseConfig";
import { FaPlus, FaTrash, FaEdit } from "react-icons/fa";
import TestimonyModal from "./TestimonyModal";
import Swal from "sweetalert2";

/* ================= STYLES ================= */

const Page = styled.div`
  padding: 2rem;
  background: #f8fafc;
  min-height: 100vh;
  position:relative;
`;

const Title = styled.h2`
  margin-bottom: 20px;
  color:#0a3cff;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
`;

const Card = styled.div`
  background: white;
  padding: 20px;
  border-radius: 15px;
  border: 1px solid #e5e7eb;
`;

const Category = styled.div`
  font-size: 0.75rem;
  color: #0a3cff;
`;

const Name = styled.h4`
  margin: 5px 0;
  color: #222;
`;

const Text = styled.p`
  font-size: 0.9rem;
  color: #222;
`;

const Meta = styled.div`
  font-size: 0.75rem;
  color: #94a3b8;
  margin-top: 8px;
`;

const Actions = styled.div`
  margin-top: 10px;
  display: flex;
  gap: 10px;

`;

const Btn = styled.button`
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 8px;
    color: #0a3cff;
`;

const AddButton = styled.button`
  position:absolute;
  top: 30px;
  right: 30px;
  background:  #0a3cff;
  color: white;
  border: none;
  padding: 5px;
  border-radius: 5px;
  cursor: pointer;
`;

/* ================= COMPONENT ================= */

export default function ManageTestimonies() {
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [search, setSearch] = useState("");

  const [form, setForm] = useState({
    title: "",
    name: "",
    category: "",
    text: "",
  });

  const testimoniesRef = collection(db, "testimonies");

  const fetchData = async () => {
    const snap = await getDocs(testimoniesRef);
    const list = snap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setData(list);
  };

  useEffect(() => {
    fetchData();
  }, []);



const handleSave = async () => {
  try {
    // Show loading alert
    Swal.fire({
      title: "Saving...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    if (editingId) {
      await updateDoc(doc(db, "testimonies", editingId), form);
    } else {
      await addDoc(testimoniesRef, {
        ...form,
        createdAt: new Date(),
      });
    }

    // Close loading alert
    Swal.close();

    // Success feedback (optional)
    Swal.fire({
      icon: "success",
      title: "Saved!",
      timer: 1500,
      showConfirmButton: false,
    });

    setShowModal(false);
    setForm({ title: "", name: "", category: "", text: "" });
    setEditingId(null);
    fetchData();
  } catch (error) {
    // Close loading alert in case of error
    Swal.close();
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.message || "Something went wrong!",
    });
  }
};

  const handleEdit = (item) => {
    setForm(item);
    setEditingId(item.id);
    setShowModal(true);
  };



const handleDelete = async (id) => {
  try {
    // Confirm before deleting
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This item will be permanently deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) return;

    // Show loading
    Swal.fire({
      title: "Deleting...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    await deleteDoc(doc(db, "testimonies", id));

    Swal.close();

    // Success message
    Swal.fire({
      icon: "success",
      title: "Deleted!",
      timer: 1500,
      showConfirmButton: false,
    });

    fetchData();
  } catch (error) {
    Swal.close();
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.message || "Failed to delete",
    });
  }
};

  // 📅 FORMAT DATE
  const formatDate = (date) => {
    if (!date) return "";
    const d = date.seconds ? new Date(date.seconds * 1000) : new Date(date);
    return d.toLocaleString("en-US", {
      month: "short",
      year: "numeric",
    });
  };


  const filteredData = data.filter((item) => {
  const name = `${item.title || ""} ${item.name || ""}`.toLowerCase();
  const category = (item.category || "").toLowerCase();
  const query = search.toLowerCase();

  return name.includes(query) || category.includes(query);
});



  return (
    <Page>
      <Title>Manage<br/> Testimonies</Title>
<input
  type="text"
  placeholder="Search by name or category..."
  value={search}
  onChange={(e) => setSearch(e.target.value)}
  style={{
    padding: "10px",
    marginBottom: "20px",
    width: "100%",
    borderRadius: "8px",
    border: "1px solid #ddd",
    outline:'none'
  }}
/>
      <Grid>
        {filteredData.map((item) => (
          <Card key={item.id}>
           <Category>
  {item.category.toUpperCase()}
</Category>

           <Name>
  {`${item.title ? item.title.charAt(0).toUpperCase() + item.title.slice(1) : ""} ${item.name ? item.name.charAt(0).toUpperCase() + item.name.slice(1) : ""}`}
</Name>

            <Text>{item.text}</Text>

            <Meta>{formatDate(item.createdAt)}</Meta>

            <Actions>
              <Btn onClick={() => handleEdit(item)}>
                <FaEdit />
              </Btn>
              <Btn onClick={() => handleDelete(item.id)}>
                <FaTrash />
              </Btn>
            </Actions>
          </Card>
        ))}
      </Grid>

      <AddButton
        onClick={() => {
          setShowModal(true);
          setEditingId(null);
          setForm({
            title: "",
            name: "",
            category: "",
            text: "",
          });
        }}
      >
        Add <FaPlus />
      </AddButton>

      {showModal && (
        <TestimonyModal
          form={form}
          setForm={setForm}
          onClose={() => setShowModal(false)}
          onSave={handleSave}
          editing={editingId}
        />
      )}
    </Page>
  );
}